module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<%\nvar categoryIndex, categoryID, toggleProperties, selectedValue;\nfor(categoryIndex in model.toggles){\ntoggleProperties = model.toggles[categoryIndex];\ncategoryID = toggleProperties.categoryID;\nselectedValue = (model.dataJSON || {})[categoryID] || 0;\n%><div class=\"row\"><%\n%><%- include('../elements/label', { model: { label: toggleProperties.name }}) %><%\n%><%- include('./toggle', { model: { dataINT: selectedValue, fieldCode: categoryID, 'integer-data': toggleProperties.options, atom: { dataType: 'integer' } }}) %><%\n%></div><%\n}\n%>\n</div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\fields\\tag-scope-category-picker-toggles.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n")
    ; __line = 2
    ; 
var categoryIndex, categoryID, toggleProperties, selectedValue;
for(categoryIndex in model.toggles){
toggleProperties = model.toggles[categoryIndex];
categoryID = toggleProperties.categoryID;
selectedValue = (model.dataJSON || {})[categoryID] || 0;

    ; __line = 8
    ; __append("<div class=\"row\">")
    ; 

    ; __line = 9
    ; __append( include('../elements/label', { model: { label: toggleProperties.name }}) )
    ; 

    ; __line = 10
    ; __append( include('./toggle', { model: { dataINT: selectedValue, fieldCode: categoryID, 'integer-data': toggleProperties.options, atom: { dataType: 'integer' } }}) )
    ; 

    ; __line = 11
    ; __append("</div>")
    ; 
}

    ; __line = 13
    ; __append("\n</div>")
    ; __line = 14
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\fields\tag-scope-category-picker-toggles.ejs

}